import { render, staticRenderFns } from "./merkez.vue?vue&type=template&id=e2817e4a"
import script from "./merkez.vue?vue&type=script&lang=js"
export * from "./merkez.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports